module.exports = __webpack_public_path__ + "static/media/13.446d6dc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/13.jpg
// module id = 703
// module chunks = 0